import Shaka from 'shaka-player/dist/shaka-player.ui'

class NekoSeekBar extends Shaka.ui.SeekBar {
  /**
   * @param {!HTMLElement} parent
   * @param {!Shaka.ui.Controls} controls
   */
  constructor(parent, controls) {
    super(parent, controls)

    const timeTip = document.createElement('label')
    timeTip.setAttribute('style',
      `display: none; position: absolute; background: #262626;
      font-family: Varela; font-size: 11px; bottom: 1rem;
      color: #fff; letter-spacing: 1.1px; padding: 2px 5px;
      transition: left 0.1s ease;`
    )

    const thumbnailTip = document.createElement('img')
    thumbnailTip.setAttribute('style',
      `display: none; position: absolute; bottom: 1rem;`
    )

    this.container.appendChild(timeTip)
    this.container.appendChild(thumbnailTip)

    this._timeTip = timeTip
    this._thumbnailTip = thumbnailTip

    this.eventManager.listen(this.container, 'mousemove', (event) => {
      this._timeTip.style.display = 'block'
      this._updateTip(event.offsetX)
    })
    this.eventManager.listen(this.container, 'mouseleave', (event) => {
      this._timeTip.style.display = 'none'
    })
  }

  /**
   * @override
   */
  release() {
    this._timeTip.remove()
    this._timeTip = null

    super.release()
  }

  /**
   * @param {Number} positionX
   * @private
   */
  _updateTip(positionX) {
    const seekRange = this.player.seekRange()
    const seekRangeSize = seekRange.end - seekRange.start
    const normalizeX = positionX / this.container.getBoundingClientRect().width
    const currentTime = seekRangeSize * normalizeX

    this._updateTimeTip(positionX, currentTime)
  }

  /**
   * @param {Number} positionX
   * @param {Number} currentTime
   * @private
   */
  _updateTimeTip(positionX, currentTime) {
    const hours = Math.floor(currentTime / 3600)
    const minutes = Math.floor((currentTime - (hours * 3600)) / 60)
    const seconds = Math.floor(currentTime - (hours * 3600) - (minutes * 60))
    const hoursStr = String(hours).padStart(2, '0') + ':'
    const minutesStr = String(minutes).padStart(2, '0') + ':'
    const secondsStr = String(seconds).padStart(2, '0')

    this._timeTip.innerText = ((hours === 0) ? '' : hoursStr) + minutesStr + secondsStr
    this._timeTip.style.left = `${positionX - (this._timeTip.clientWidth / 2)}px`
  }

  /**
   * 未使用
   * [NOTE]
   * サムネイルは別途トラックが必要になるため、パッケージング時に
   * ImageTrack の追加が必要になる
   * @private
   */
  _updatteThumbnailTip(currentTime) {
    const tracks = this.player.getImageTracks()
    const activeTrack = tracks.find(track => track.active)
    if (activeTrack) {
      this.player.getThumbnails(activeTrack.id, currentTime)
        .then(thumbnail => console.log(thumbnail))
        .catch(error => console.error(error))
    }
  }
}

NekoSeekBar.Factory = class {
  create(rootElement, controls) {
    return new NekoSeekBar(rootElement, controls)
  }
}

export default NekoSeekBar
